type EmbedRenderer = {
  rootContainer: ShadowRoot;
  renderApp: () => void;
};

const mountedEmbeds = new Set<EmbedRenderer>();

export function registerMountedEmbed(embed: EmbedRenderer) {
  mountedEmbeds.add(embed);
}

export function unregisterMountedEmbed(embed: EmbedRenderer) {
  mountedEmbeds.delete(embed);
}

export function forEachMountedShadowRoot(callback: (root: ShadowRoot) => void) {
  for (const embed of mountedEmbeds) {
    if (!embed.rootContainer.host.isConnected) {
      mountedEmbeds.delete(embed);
      continue;
    }

    callback(embed.rootContainer);
  }
}

export function rerenderMountedEmbeds() {
  for (const embed of mountedEmbeds) {
    if (!embed.rootContainer.host.isConnected) {
      mountedEmbeds.delete(embed);
      continue;
    }

    embed.renderApp();
  }
}

export function clearMountedEmbeds() {
  mountedEmbeds.clear();
}
